import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import Segment from './segment';

import './double.css';

const Double = ({ block }) => {
  const leftBlock = block.getIn(['fields', 'segments', 'blocks', 0]);
  const rightBlock = block.getIn(['fields', 'segments', 'blocks', 1]);

  return (
    <div className="block-double">
      <div className="segments">
        <div className="left">
          <div className="inner">
            {leftBlock ? <Segment segment={leftBlock} /> : null}
          </div>
        </div>
        <div className="right">
          <div className="inner">
            {rightBlock ? <Segment segment={rightBlock} /> : null}
          </div>
        </div>
      </div>
    </div>
  );
};

Double.propTypes = {
  block: PropTypes.instanceOf(Map).isRequired,
};

export default Double;



// WEBPACK FOOTER //
// ./src/components/blocks/double/index.jsx